'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartBody = PushCartBody;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PushCartItem = require('./PushCartItem');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartBody(_ref) {
  var lineItems = _ref.lineItems;

  return _react2.default.createElement('div', { className: 'psh-Body' }, _react2.default.createElement('ul', { className: 'psh-Body_Items' }, lineItems.map(function (lineItem) {
    return _react2.default.createElement('li', { className: 'psh-Body_Item', key: lineItem.key }, _react2.default.createElement(_PushCartItem.PushCartItem, { lineItem: lineItem }));
  })), _react2.default.createElement('div', { className: 'psh-Body_Loading' }, _react2.default.createElement('svg', { viewBox: '0 0 44 44', xmlns: 'http://www.w3.org/2000/svg', stroke: '#fff' }, _react2.default.createElement('g', { fill: 'none', fillRule: 'evenodd', strokeWidth: '2' }, _react2.default.createElement('circle', { cx: '22', cy: '22', r: '1' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    begin: '0s',
    dur: '1.8s',
    values: '1; 20',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.165, 0.84, 0.44, 1',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'stroke-opacity',
    begin: '0s',
    dur: '1.8s',
    values: '1; 0',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.3, 0.61, 0.355, 1',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '22', cy: '22', r: '1' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    begin: '-0.9s',
    dur: '1.8s',
    values: '1; 20',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.165, 0.84, 0.44, 1',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'stroke-opacity',
    begin: '-0.9s',
    dur: '1.8s',
    values: '1; 0',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.3, 0.61, 0.355, 1',
    repeatCount: 'indefinite'
  }))))));
}

PushCartBody.propTypes = {
  lineItems: _propTypes2.default.array.isRequired
};